// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import service from './service'
// import PlayerCdn from 'playerCdn'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n);
// Vue.use(PlayerCdn);

Vue.prototype.$service = service;
const messages = {
  en: {
    message: {
      pageNotFound: 'Nothing Found',
        pageNotAllowed: 'permission denied',
    }
  },
  fr: {
    message: {
      pageNotFound: "Rien n'a été trouvé",
        pageNotAllowed: "Permission refusée",
    }
  }
}
// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: 'fr', // set locale
  messages, // set locale messages
  silentTranslationWarn: true // IGNORE LOGS
})
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  service: service,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js